
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sneaker-release/[brand]",
      function () {
        return require("private-next-pages/sneaker-release/[brand]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sneaker-release/[brand]"])
      });
    }
  